import { useNavigate } from "react-router-dom";
import {
  UilShoppingCart,
  UilCheckCircle,
  UilCalendarAlt,
  UilBox,
  UilMoneyWithdrawal,
} from "@iconscout/react-unicons";

/* ── icon map ── */
const ICON_MAP = {
  shopping: UilShoppingCart,
  check:    UilCheckCircle,
  calendar: UilCalendarAlt,
  box:      UilBox,
  sales:    UilMoneyWithdrawal,
};

/* ── accent colours derived from the color field in Data.js ── */
const ACCENT_MAP = {
  blue:    { bubble: "bg-blue-100",    icon: "text-blue-600",    bar: "bg-blue-500" },
  emerald: { bubble: "bg-emerald-100", icon: "text-emerald-600", bar: "bg-emerald-500" },
  violet:  { bubble: "bg-violet-100",  icon: "text-violet-600",  bar: "bg-violet-500" },
  rose:    { bubble: "bg-rose-100",    icon: "text-rose-600",    bar: "bg-rose-500" },
  amber:   { bubble: "bg-amber-100",   icon: "text-amber-600",   bar: "bg-amber-500" },
  cyan:    { bubble: "bg-cyan-100",    icon: "text-cyan-600",    bar: "bg-cyan-500" },
};

function resolveAccent(colorClass) {
  for (const [key, val] of Object.entries(ACCENT_MAP)) {
    if (colorClass?.includes(key)) return val;
  }
  return ACCENT_MAP.blue;
}

function formatValue(title, count, currencySymbol) {
  if (title.includes("Sales"))
    return `${currencySymbol}${Number(count).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  if (title.includes("Rating"))
    return `${Number(count).toFixed(1)} / 5`;
  return Number(count).toLocaleString();
}

function ModernCard({ param, currencySymbol }) {
  const navigate = useNavigate();
  const count    = param.series?.[0]?.data?.[0] ?? 0;
  const Icon     = ICON_MAP[param.icon] || UilShoppingCart;
  const accent   = resolveAccent(param.color);

  return (
    <div
      onClick={() => param.link && navigate(param.link)}
      className="relative bg-white rounded-2xl border border-gray-100 shadow-sm
                 hover:shadow-md active:scale-[0.98] transition-all duration-200
                 cursor-pointer overflow-hidden"
    >
      {/* coloured top accent bar */}
      <div className={`h-1 w-full ${accent.bar}`} />

      <div className="p-5">
        {/* icon bubble */}
        <div className={`w-11 h-11 rounded-xl ${accent.bubble} flex items-center justify-center mb-4`}>
          <Icon size={22} className={accent.icon} />
        </div>

        {/* metric */}
        <p className="text-2xl font-bold text-gray-900 leading-none mb-1.5 tracking-tight">
          {formatValue(param.title, count, currencySymbol)}
        </p>

        {/* label */}
        <p className="text-sm text-gray-500 font-medium">{param.title}</p>
      </div>
    </div>
  );
}

const Card = ({ currencySymbol, ...rest }) => (
  <ModernCard param={rest} currencySymbol={currencySymbol} />
);

export default Card;
